export enum EPartialStyle {
  Default,
  Success,
  Danger,
  Accent,
  Info,
}
